module.exports = fox._r("fonts/robotocondensed-regular-webfont.woff2", __webpack_public_path__ + "_/_/_/root/fonts/35EcagY.woff2");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-regular-webfont.woff2
// module id = 164
// module chunks = 4